// extracted by mini-css-extract-plugin
export default {"wrapper":"arolla-pine-trail-module--wrapper--09a90","image":"arolla-pine-trail-module--image--513cd","content":"arolla-pine-trail-module--content--a1f35"};